import { type Editor } from '@tiptap/react';
import { PanelLeftCloseIcon } from 'lucide-react';

import { DropdownMenuWrapper, useDropdownMenuState } from '@/components/ui/tiptap/tiptap-ui-primitives';
import { useIsTableInactive } from '@/components/ui/tiptap/tiptap-ui/table';
import { useTiptapEditor } from '@/hooks/tiptap';
import { isNodeInSchema, shouldShow } from '@/lib/tiptap';

import type { AddColRowDropdownMenuProps, AddTableElementType } from '.';

import { AddColRowButton, addColRowOptions } from '.';

export function AddColRowDropdownMenu(addColRowDropdownMenuProps: AddColRowDropdownMenuProps) {
  const { editor: providedEditor, onOpenChange, types = ['addColumnBefore', 'addColumnAfter', 'addRowBefore', 'addRowAfter'], ...props } = addColRowDropdownMenuProps;

  const editor: Editor | null = useTiptapEditor(providedEditor);
  const inSchema: boolean = isNodeInSchema('table', editor);
  const isDisabled: boolean = useIsTableInactive(editor);

  const { isOpen, filteredItems, handleOpenChange, activeIcon } = useDropdownMenuState<AddTableElementType>(editor, types, addColRowOptions, undefined, <PanelLeftCloseIcon />);
  const show: boolean = shouldShow([!!editor, inSchema]);

  if (!show || !editor || !editor.isEditable) {
    return null;
  }
  return (
    <DropdownMenuWrapper
      isOpen={isOpen}
      onOpenChange={(open) => handleOpenChange(open, onOpenChange)}
      ariaLabel="add column or row"
      buttonProps={props}
      activeIcon={activeIcon()}
      isDisabled={isDisabled}
      isActive={false}
    >
      <>
        {filteredItems.map((option) => (
          <AddColRowButton key={option.type} editor={editor} type={option.type} />
        ))}
      </>
    </DropdownMenuWrapper>
  );
}
